export enum FillsGraphStreamElementType {
    Snap = 103, //Arrival price
    TotBuyFills = 105, // Aggregated buy fill value/quantity
    TotSellFills = 106, // Aggregated sell fill value/quantity
    CostUpdate = 108, //Impact cost
    Vwap = 109, // ORDERVWAP / VWAPUPDATE
    StrategyParams = 110, // STRATEGYPARMS
    OrderOpen = 111,
}
